import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import * as widgetsActions from "../../../../redux/Widgets/actions";
import StackedBarChart from "../../../../components/Charts/StackedBar";
import {createChartDatasets, getFieldValues} from "../common.js";
import ViewReportLink from "../ViewReportLink.js";

const widgetName = "HeatmapByEngagement";

const HeatmapByEngagement = props => {
	const widget = useSelector(state => state.widget).widgets[widgetName];
	const user = useSelector(state => state.user.user);
	const dispatch = useDispatch();

	useEffect(() => {
		const load = async () => {
			await dispatch(widgetsActions.loadWidget(widgetName))
		};
		load();
	}, [user]);

	const loading = widget == null || widget.status === "loading" || widget.data == null || widget.data.data == null ;

	if(loading) {
		return (
			<div />
		)
	}

	const labelField = 'Engagement_Status__c';
	const categoryField = 'Contact_Classification_1__c';
	const labels = getFieldValues(widget.data.data, labelField);
	const categories = getFieldValues(widget.data.data, categoryField);
	const datasets = createChartDatasets(widget.data.data, categories, categoryField, labels, labelField);

	return (
		<div className="widget-container">
			<div className="widget-title">Heatmap by Engagement Status ({widget.data.data.length})</div>
			<div style={{width: '90%', height: '75%', paddingTop: '50px', paddingRight: '30px', display: 'flex', justifyContent: 'center'}}>
				<StackedBarChart labels={labels} datasets={datasets} />
			</div>
			<ViewReportLink onClick={() => props.showReport(widget)} />
		</div>
	)
};

export default HeatmapByEngagement;